import { createFileRoute } from "@tanstack/react-router";
import { BrandingContainer } from "@/features/branding/containers/branding-container";

export const Route = createFileRoute("/app/settings/organisation/branding")({
  component: BrandingContainer,
});
